import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import HbLink from '../Link/HbLink';
import HbJewel from '../Jewel/HbJewel';
import HbBouncingIndicator from '../Indicator/bouncing/HbBouncingIndicator';
import {
  HB_BUTTON_VISUAL_TYPE_CONFIGS,
  HB_BUTTON_VISUAL_TYPES,
} from './hbButtonVisualTypes';
import s from './hb-button.scss';

export const propTypes = {
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  textClassName: PropTypes.string,
  iconContainerClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  tabIndex: PropTypes.number,
  text: PropTypes.string,
  hasIcon: PropTypes.bool,
  type: PropTypes.string,
  isDisabled: PropTypes.bool,
  isPending: PropTypes.bool,
  visualType: PropTypes.string,
  anchorHref: PropTypes.string,
  anchorTarget: PropTypes.string,
  anchorRel: PropTypes.string,
  customAnchorProps: PropTypes.object,
  iconJewelText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  PendingIndicatorComponent: PropTypes.func,
  pendingIndicatorProps: PropTypes.object,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
};

export const defaultProps = {
  type: 'button',
  hasIcon: false,
  isPending: false,
  tabIndex: 0,
  PendingIndicatorComponent: HbBouncingIndicator,
};

class HbButton extends PureComponent {
  static propTypes = propTypes

  static defaultProps = defaultProps

  handleMouseDown = (event) => {
    const {isPending, onMouseDown} = this.props;

    if (!isPending) {
      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }

  handleClick = (event) => {
    const {
      isPending,
      onClick,
      isDisabled,
      anchorHref,
    } = this.props;

    if (anchorHref && onClick) {
      event.preventDefault();
    }

    if (!isPending && !isDisabled) {
      if (onClick) {
        onClick(event);
      }
    }
  }

  render() {
    const {
      className,
      contentClassName,
      textClassName,
      iconClassName,
      iconContainerClassName,
      text,
      hasIcon,
      tabIndex,
      isDisabled,
      type,
      isPending,
      visualType,
      anchorHref,
      anchorTarget,
      anchorRel,
      customAnchorProps,
      iconJewelText,
      PendingIndicatorComponent,
      pendingIndicatorProps,
      dataHbus,
      dataTestId,
      forceRedirect,
      pendingIndicatorCircle,
    } = this.props;

    let RootNodeType, rootNodeProps;

    if (anchorHref) {
      RootNodeType = HbLink;
      rootNodeProps = {
        isDisabled,
        to: isDisabled ? '' : anchorHref,
        customAnchorProps,
        target: anchorTarget,
        rel: anchorRel,
        forceRedirect
      };
    } else {
      RootNodeType = 'button';
      rootNodeProps = {
        disabled: isDisabled,
        type,
      };
    }

    const containerClassName = cx(
      s.root,
      'hb-HbButton',
      HB_BUTTON_VISUAL_TYPE_CONFIGS[visualType] &&
      s[HB_BUTTON_VISUAL_TYPE_CONFIGS[visualType].className],
      className,
      {
        [s.isPending]: isPending,
        [s.isAnchor]: Boolean(anchorHref),
        [s.isDisabledWithAnchor]: anchorHref && isDisabled,
      }
    );

    return (
      <RootNodeType
        {...rootNodeProps}
        className={containerClassName}
        tabIndex={tabIndex}
        disabled={isDisabled}
        type={type}
        onMouseDown={this.handleMouseDown}
        onClick={this.handleClick}
        data-test-id={dataTestId}
        data-hbus={dataHbus ? dataHbus : ''}>
        <span className={cx(s.content, contentClassName, 'hb-button__content')}>
          {!isPending && hasIcon && (
            <span
              className={cx(s.iconContainer, iconContainerClassName, 'hb-button__icon-container')}>
              <span className={cx(s.icon, iconClassName, 'hb-button__icon')} />

              {(iconJewelText === 0 || iconJewelText) && (
                <HbJewel
                  className={cx(s.iconJewel, 'hb-button__icon-Jewel')}
                  text={iconJewelText}
                />
              )}
            </span>
          )}

          {isPending && !pendingIndicatorCircle && PendingIndicatorComponent && (
            <PendingIndicatorComponent
              {...pendingIndicatorProps}
              className={cx(
                s.pendingIndicator,
                pendingIndicatorProps && pendingIndicatorProps.className,
                'hb-button__pending-indicator'
              )}
            />
          )}

          {isPending && pendingIndicatorCircle && <div className={s.isPendingLoader} />}

          {!isPending && text && (
            <span className={cx(s.text, textClassName, 'hb-button__text')}>{text}</span>
          )}
        </span>
      </RootNodeType>
    );
  }
}

export default HbButton;
export {
  HB_BUTTON_VISUAL_TYPES,
};
